import { useContext, useState, useEffect } from 'react';
import PageContext from "./PageContext";
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton'; 
import InputDataTableDynamic from './InputDataTableDynamicCopy.jsx';
import InputTableRow from './InputTableRow'; 
import validateInputArray from '../functions/validateInputArray'; 
import dynamicValidation from '../functions/dynamicValidation';
import dynamicTransformation from '../functions/dynamicTransformation';
import copyObjectToArray from '../functions/copyObjectToArray';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const AddRetentionBonusModal = () => {
    // get context from parent
    const {
        addRetentionBonusModal, 
        setAddRetentionBonusModal, 
        masterCompanyData,
        getRefreshData,  
        snackbarAlert, 
        retentionBonusConfig, 
        retentionBonusLists,
        retentionClawbackConfig, 
        retentionClawbackLists,
        showSpinner
    } = useContext(PageContext);
    // get http context from parent
    const {
        POST
    } = useContext(HttpContext); 
    // initialize state
    const [valuesBonus, setValuesBonus] = useState([]); 
    const [configBonus, setConfigBonus] = useState([]); 
    const [errorBonus, setErrorBonus] = useState([{}]);
    const [valuesClawback, setValuesClawback] = useState([]); 
    const [configClawback, setConfigClawback] = useState([]); 
    const [errorClawback, setErrorClawback] = useState([{}]);

    // function wrapper to pass row component
    const RowComponentBonus = ( data, setData, count, config, length, setLength,addButtonText ) => { 
        return <InputTableRow data={data} setData={setData} count={count} config={config} length={length} setLength={setLength} lists={retentionBonusLists} error={errorBonus} setError={setErrorBonus}  addButtonText={addButtonText}/>
    }

    // function wrapper to pass row component
    const RowComponentClawback = ( data, setData, count, config, length, setLength, addButtonText ) => { 
        return <InputTableRow data={data} setData={setData} count={count} config={config} length={length} setLength={setLength} lists={retentionClawbackLists} error={errorClawback} setError={setErrorClawback} addButtonText={addButtonText}/>
    }

    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            // -- BONUSES -- 
            // run dynamic validation on input array
            let requestValuesBonus = copyObjectToArray(valuesBonus); 
            // validate input
            let checkError = validateInputArray(
                requestValuesBonus, 
                retentionBonusConfig,
                dynamicValidation,
                retentionBonusLists, 
                snackbarAlert,  
                errorBonus, 
                setErrorBonus, 
                dynamicTransformation, 
                { }
            ); 
            // exit request if error 
            if (checkError) {
                reject(); 
                return; 
            }           
            console.log(valuesBonus); 
            // -- CLAWBACKS -- 
            // run dynamic validation on input array
            let requestValuesClawback = copyObjectToArray(valuesClawback); 
            // slice off blank row 
            requestValuesClawback = requestValuesClawback.slice(0, requestValuesClawback.length-1); 
            // validate input
            checkError = validateInputArray(
                requestValuesClawback, 
                retentionClawbackConfig,
                dynamicValidation,
                retentionClawbackLists, 
                snackbarAlert,  
                errorClawback, 
                setErrorClawback, 
                dynamicTransformation, 
                { }
            ); 
            // exit request if error 
            if (checkError) {
                reject(); 
                return; 
            }    
            console.log(valuesClawback);       
            // make post request 
            let response; 
            POST('/client/retentionBonus', {
                mastercompanyid: masterCompanyData['mastercompanyid'], 
                BonusArgs: requestValuesBonus[0], 
                ClawbackArgs: requestValuesClawback
            }).then(res => {
                response = res; 
                // hide modal 
                setAddRetentionBonusModal(addRetentionBonusModal => addRetentionBonusModal = false); 
                // default values 
                let obj = { blank: false }; 
                // add all defaults to object
                for (let i = 0; i < retentionBonusConfig.length; i++) {
                    if (retentionBonusConfig[i]['columnid'] == 'startdate'){
                        obj['startdate'] = new Date(); 
                    }
                    else if (retentionBonusConfig[i]['columnid'] == 'active') {
                        obj['active'] = retentionBonusLists['active'][0]; 
                    }
                    else {
                        obj[retentionBonusConfig[i]['columnid']] = ''; 
                    }
                }
                setValuesBonus(valuesBonus => valuesBonus = [obj]); 
                obj = { blank: true }; 
                setValuesClawback(valuesClawback => valuesClawback = [obj]); 
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh CompanyDetailsPage using function from parent
                return getRefreshData();
            }).then(res => {
                console.log(res); 
                // resolve on success
                resolve(res); 
            }).catch(err => {   
                console.log(err); 
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            }); 
        });
    }

    // useEffect to run on config change
    useEffect(() => {
        if (retentionBonusConfig) {
            // set the config 
            setConfigBonus(configBonus => configBonus = retentionBonusConfig); 
            // initialize values object 
            let obj = { blank: false }; 
            // add all defaults to object
            for (let i = 0; i < retentionBonusConfig.length; i++) {
                if (retentionBonusConfig[i]['columnid'] == 'startdate'){
                    obj['startdate'] = new Date(); 
                }
                else if (retentionBonusConfig[i]['columnid'] == 'active') {
                    obj['active'] = retentionBonusLists['active'][0]; 
                }
                else {
                    obj[retentionBonusConfig[i]['columnid']] = ''; 
                }
            }
            // set values state
            setValuesBonus(valuesBonus => valuesBonus = [obj]); 
        }
    }, [retentionBonusConfig]); 

    // useEffect to run on config change
    useEffect(() => {
        if (retentionClawbackConfig) {
            // set the config 
            setConfigClawback(configClawback => configClawback = retentionClawbackConfig); 
            // initialize values object 
            let obj = { blank: true }; 
            // set values state
            setValuesClawback(valuesClawback => valuesClawback = [obj]); 
        }
    }, [retentionClawbackConfig]); 

    return (
        <> 
            <CCOffcanvas
                title='Add Retention Bonus'
                show={addRetentionBonusModal}
                onCanvasClose={()=>setAddRetentionBonusModal(addRetentionBonusModal => addRetentionBonusModal = false)}
                bodyCssClassName="offcanvas-body"
                offCanvasClassName="offcanvas-parent-card"
            >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column flex-grow-1 overflow-scroll">
                        <div className="p-3 pt-1 trail-section">
                            <div className="bg-white trail-card">
                                <InputDataTableDynamic disableMaxTableHeight={true} RowComponent={RowComponentBonus} config={configBonus} dataList={valuesBonus} setDataList={setValuesBonus} showSpinner={showSpinner} addButtonText='Add Retention Bonus' />
                            </div>       
                        </div>   
                        <div className="p-3 trail-section">
                            <div className="bg-white trail-card">
                                <InputDataTableDynamic disableMaxTableHeight={true} RowComponent={RowComponentClawback} config={configClawback} dataList={valuesClawback} setDataList={setValuesClawback} showSpinner={showSpinner} addButtonText='Add Clawback'/>
                            </div>       
                        </div>                     
                    </div>
                    {/* button to submit edits to rebate setup */}
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={()=>setAddRetentionBonusModal(addRetentionBonusModal => addRetentionBonusModal = false)}
                            />
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    ); 
}

export default AddRetentionBonusModal; 